import React, { Component } from 'react';
import moment from 'moment';
import AsyncSelect from 'react-select/async';

export default class InventoryShowEdit extends Component {

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    let date_created = this.props.inventory.date_created ? moment(this.props.inventory.date_created).format('LL') : '',
        packing_date = this.props.inventory.packing_date ? moment(this.props.inventory.packing_date).format('LL') : '-',
        date_produced = this.props.inventory.date_produced ? moment(this.props.inventory.date_produced).format('LL') : '',
        expiration_date = this.props.inventory.expiration_date ? moment(this.props.inventory.expiration_date).format('LL') : '-',
        location_date = this.props.inventory.location_date ? moment(this.props.inventory.location_date).format('LL') : '-',
        current_location = this.props.inventory.current_location ?
          `${this.props.inventory.current_location.name} - Moved by ${this.props.inventory.location_user || 'Unknown'} on ${location_date}` : '-';
    return (
      <div className="">
        <div>
            <div className="card-item">
              <div className="col-sm-2"><span><b>Currently: </b></span></div>
              <div className="col-sm-10">
                {this.props.inventory.active ?
                  <span className="badge badge-pill badge-success">Active</span>
                  :
                  <span className="badge badge-pill badge-danger">Inactive</span>
                }
              </div>
            </div>
            <div className="card-item">
                {/*/////////////////////////////////////////////////////////
                                        STATION
                  ////////////////////////////////////////////////////////*/}
              <div className="col-sm-2"><span><b>Station: </b></span></div>
              <div className="col-sm-10">
              { this.props.editMode ?
                <div className={`col-sm-5 p-0 ${(this.props.errors.indexOf('station') !== -1) ? " has-danger" : ""}`}>
                  <select id="select" name="select" className={`form-control ${(this.props.errors.indexOf('station') !== -1) ? " form-control-danger" : ""}`} size="1" value={this.props.editInventory.station_index} onChange={(station) => this.props.onStationChange(station)}>
                      {this.props.editInventory.station_index < 0 ? <option value={-1}>{this.props.inventory.station? this.props.inventory.station.name : 'Select station'}</option> : ''}
                      {this.props.stationsList ? (this.props.stationsList.map((station,index) => {
                            return(<option value={index} label={station.name} key={station.id}>{station.name}</option>)
                          })) : <option value=" ">Loading...</option>
                      }
                  </select>
                </div>
                :
                <span className="badge badge-pill badge-warning">{this.props.inventory.station.name}</span>
              }
              </div>
            </div>

            {/*/////////////////////////////////////////////////////////
                                    Item
              ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2"><span><b>Item: </b></span></div>
              <div className="col-sm-10">
              { this.props.editMode ?
                <div className='col-sm-5 p-0'>
                  <AsyncSelect
                  name="form-field-name"
                  matchProp="label"
                  loadOptions={this.props.itemSearch}
                  isLoading={this.props.itemIsLoadingSearch}
                  onChange={this.props.onItemChange}
                  value={this.props.selectedItem}
                  placeholder={this.props.placeholderItem}
                  defaultOptions
                  theme={theme => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                      ...theme.colors,
                      neutral20: '#dbdee0',
                    }
                  })}
                  />
                </div>
              :
                <span>{this.props.inventory.item.name}</span>
              }
              </div>
            </div>


            {/*///////////////////////////////////////////////////////
                                  BRAND
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2"><span><b>Brand: </b></span></div>
              <div className="col-sm-10">
              { this.props.editMode ?
                <div className={`col-sm-5 p-0 ${(this.props.errors.indexOf('brand') !== -1) ? " has-error" : ""}`}>
                  <select id="select" name="select" className={`form-control ${(this.props.errors.indexOf('brand') !== -1) ? " form-control-danger" : ""}`} size="1" value={this.props.editInventory.brand_index} onChange={(brand) => this.props.onBrandChange(brand)}>
                    { this.props.editInventory.brand_index < 0 ? <option value={-1}>Select brand</option> : '' }
                    {this.props.brandsList ? (this.props.brandsList.map((brand,index) => {
                          return(<option value={index} label={brand.name} key={brand.id}>{brand.brand_name}</option>)
                        })) : <option value=" ">Loading...</option>
                    }
                  </select>
                </div>
                :
                <span>{this.props.inventory.brand ? this.props.inventory.brand.brand_name : '-'}</span>
              }
              </div>
            </div>
            <div className="card-item">
            {/*///////////////////////////////////////////////////////
                                  GRADE
            ////////////////////////////////////////////////////////*/}
              <div className="col-sm-2"><span><b>Grade: </b></span></div>
              <div className="col-sm-10">
              { this.props.editMode ?
                <div className="col-sm-5 p-0">
                  <select id="select" name="select" className="form-control" size="1" value={this.props.editInventory.grade_index} onChange={(grade) => this.props.onGradeChange(grade)}>
                      {this.props.editInventory.grade_index < 0 ? <option value={-1}>{(this.props.inventory.extra_info && this.props.inventory.extra_info.grade)? this.props.inventory.extra_info.grade.grade: 'N/A'}</option> : ''}
                      {this.props.gradesList ? (this.props.gradesList.map((grade,index) => {
                            return(<option value={index} label={grade.grade} key={grade.id}>{grade.grade}</option>)
                          })) : <option value=" ">Loading...</option>
                      }
                  </select>
                </div>
                :
                <span>{(this.props.inventory.extra_info && this.props.inventory.extra_info.grade)? this.props.inventory.extra_info.grade.grade: 'N/A'}</span>
              }
              </div>
            </div>
            {/*///////////////////////////////////////////////////////
                                  Weight
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2"><span><b>Weight: </b></span></div>
              <div className="col-sm-10">
                { this.props.editMode ?
                  <div className="col-sm-5 d-flex align-items-center p-0">
                    <input type="number" id="text-input" name="text-input" className={`form-control mr-05 ${(this.props.errors.indexOf('weight') !== -1) ? " form-control-danger" : ""}`} placeholder={'Enter weight'} value={this.props.editInventory.weight} onChange={(weight) => this.props.onWeightChange(weight)}/>
                    <span>{this.props.inventory.item.measure_unit ? this.props.inventory.item.measure_unit : 'kg'}</span>
                  </div>
                  :
                  (this.props.inventory.weight === null) ?
                   '-'
                   :
                  <span>{this.props.inventory.weight || 0} {this.props.inventory.item.measure_unit ? this.props.inventory.item.measure_unit : 'kg'}</span>
                }
              </div>
            </div>
            {!this.props.inventory.item.allows_leftovers &&
             <div className="card-item">
              <div className="col-sm-2"><span><b>Actual weight: </b></span></div>
                <div className="col-sm-10">
                  <span>{this.props.inventory.actual_weight || 0} {this.props.inventory.item.measure_unit ? this.props.inventory.item.measure_unit : 'kg'}</span>
                </div>
              </div>}
            {/*///////////////////////////////////////////////////////
                                  Vendor
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2"><span><b>Vendor: </b></span></div>
              <div className="col-sm-10"><span>{this.props.inventory.vendor ? this.props.inventory.vendor : '-' }</span></div>
            </div>
            {/*///////////////////////////////////////////////////////
                                  Vendor Lot Number
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2">
                <span>
                  <b>Lot: </b>
                </span>
              </div>
              <div className="col-sm-10">
                <span>{this.props.inventory.vendor_lot_number ? this.props.inventory.vendor_lot_number : "-"}</span>
              </div>
            </div>
            {/*///////////////////////////////////////////////////////
                                  Plant
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2"><span><b>Plant: </b></span></div>
              <div className="col-sm-10"><span>{this.props.inventory.plant ? this.props.inventory.plant : '-' }</span></div>
            </div>
            {/*///////////////////////////////////////////////////////
                                  Price
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2"><span><b>Production Cost: </b></span></div>
              <div className="col-sm-10">
              { this.props.editMode ?
                <div className="col-sm-5 p-0">
                  <input type="number" id="text-input" name="text-input" className={`form-control ${(this.props.errors.indexOf('price') !== -1) ? " form-control-danger" : ""}`} placeholder={'Enter price'} value={this.props.editInventory.price} onChange={(price) => this.props.onPriceChange(price)}/>
                </div>
                :
                <span>{(this.props.inventory.price ===null? '-' : this.props.inventory.price)}</span>
              }
              </div>
            </div>
            <div className="card-item">
              <div className="col-sm-2"><span><b>Selling Price: </b></span></div>
              <div className="col-sm-10">
                <span>{(this.props.inventory.shipment_price === null? '-' : this.props.inventory.shipment_price)}</span>
              </div>
            </div>
            { date_created ?
              <div className="card-item">
                <div className="col-sm-2"><span><b>Date Received: </b></span></div>
                <div className="col-sm-10"><span>{date_created}</span></div>
              </div>
              :
              <div className="card-item">
                <div className="col-sm-2"><span><b>Date Produced: </b></span></div>
                <div className="col-sm-10"><span>{date_produced}</span></div>
              </div>
            }
            <div className="card-item">
              <div className="col-sm-2"><span><b>Expiration Date: </b></span></div>
              <div className="col-sm-10"><span>{expiration_date}</span></div>
            </div>

            <div className="card-item">
            {/*///////////////////////////////////////////////////////
                                  Packing Date
            ////////////////////////////////////////////////////////*/}
              <div className="col-sm-2"><span><b>Date Packed: </b></span></div>
              <div className="col-sm-10">
              { this.props.editMode ?
                <div className="col-sm-5 p-0">
                  <input type="date" id="date" className={`form-control`} value={moment(this.props.editInventory.packing_date).format('YYYY-MM-DD')}  onChange={(date) => this.props.onPackingDateChange(date)}/>
                </div>
                :
                <span>{packing_date}</span>
              }
              </div>
            </div>

            <div className="card-item">
              <div className="col-sm-2"><span><b>Last Temperature: </b></span></div>
              <div className="col-sm-10"><span> {this.props.inventory.temperatures.length > 0 ? this.props.inventory.temperatures[this.props.inventory.temperatures.length - 1].value + ' ºF': '-'}</span></div>
            </div>

            {/*///////////////////////////////////////////////////////
                                  Current Location
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2"><span><b>Current Location: </b></span></div>
              <div className="col-sm-10">
                <span>{current_location}</span>
              </div>
            </div>

            {/*///////////////////////////////////////////////////////
                                    Box Condition
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2">
                <span>
                  <b>Box Condition: </b>
                </span>
              </div>
              <div className="col-sm-10">
                <span>{this.props.inventory.box_condition ? this.props.inventory.box_condition : "-"}</span>
              </div>
            </div>

            {/*///////////////////////////////////////////////////////
                                    Transport Condition
            ////////////////////////////////////////////////////////*/}
            <div className="card-item">
              <div className="col-sm-2">
                <span>
                  <b>Transport Condition: </b>
                </span>
              </div>
              <div className="col-sm-10">
                <span>{this.props.inventory.transport_condition ? this.props.inventory.transport_condition : "-"}</span>
              </div>
            </div>

            {!this.props.inventory.active && (this.props.inventory.delete_user || this.props.inventory.delete_message) ?
              <div>
                <div className="card-item">
                  <div className="col-sm-2"><span><b>Delete message: </b></span></div>
                  <div className="col-sm-10"><span> {this.props.inventory.delete_message ? this.props.inventory.delete_message : '-'}</span></div>
                </div>
                <div className="card-item border-0">
                  <div className="col-sm-2"><span><b>Waste category: </b></span></div>
                  <div className="col-sm-10"><span> {this.props.inventory.waste_category ? this.props.inventory.waste_category.name : '-'}</span></div>
                </div>
              </div> : null}
          </div>
        </div>
      );
  }
}
